import React, { useRef } from 'react';
import { motion } from 'framer-motion';

function Hero() {
  const containerRef = useRef(null);

  return (
    <section ref={containerRef} className="relative w-full h-[72vh] min-h-[520px] overflow-hidden">
      {/* Hero background image */}
      <div
        className="absolute inset-0 w-full h-full bg-cover bg-center"
        style={{
          backgroundImage: "url('/new-assets/pexels-vlada-karpovich-7433824.jpg')"
        }}
      />

      {/* Static overlay */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'linear-gradient(to bottom, rgba(3,7,15,0.45), rgba(2,6,13,0.62))'
        }}
      />

      {/* Content */}
      <div className="relative z-10 flex h-full items-center justify-center text-center px-6">
        <div className="max-w-5xl">
          <motion.h1
            className="text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light tracking-[-0.02em] drop-shadow-[0_4px_12px_rgba(0,0,0,0.6)]"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
          >
            <motion.span 
              className="block font-light"
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, delay: 0.3 }}
            >
              Wealth Management
            </motion.span>
            <motion.span 
              className="block font-medium text-[#fbbf24] mt-1"
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
            >
              Redefined
            </motion.span>
          </motion.h1>
          
          <motion.div
            className="mt-6 max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: 'easeOut', delay: 0.1 }}
          >
            <p className="text-white/95 text-xl sm:text-2xl md:text-3xl font-light leading-snug">
              Sophisticated wealth management for discerning investors.
            </p>
          </motion.div>
          <motion.div
            className="mt-6 flex justify-center items-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.7 }}
          >
            <motion.a 
              href="/apply" 
              className="group relative px-8 py-3 sm:px-9 sm:py-3.5 rounded-full bg-gradient-to-r from-[#fbbf24] to-[#f59e0b] hover:from-[#f59e0b] hover:to-[#d97706] text-black font-medium text-lg transition-all duration-500 shadow-2xl hover:shadow-amber-500/30 overflow-hidden"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <span className="relative z-10">Apply Now</span>
              <motion.div 
                className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent"
                initial={{ opacity: 0, x: "-100%" }}
                whileHover={{ opacity: 1, x: "0%" }}
                transition={{ duration: 0.6 }}
              />
            </motion.a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}

export default Hero;


